export default __webpack_public_path__ + "static/media/people8small.fe2ab12e.jpg";